import React from 'react';
import { connect } from 'react-redux';
// import FontIcon from 'react-toolbox/lib/font_icon';
import Title from '~/components/Title';
import Tag from '~/components/Tag';
import { get } from '~/actions/work';
import style from './style.scss';

class Work extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: !this.props.item && this.props.id
    };
  }

  componentDidMount() {
    if (this.state.loading) {
      get(this.props.dispatch, this.context.apiClient, this.props.id)
        .then(() => this.setState({ loading: false }))
        .catch(() => this.setState({ loading: false }));
    }
  }

  renderItem() {
    const work = this.props.item.toJS();
    const action = this.props.action ? this.props.action.toJS() : {};
    return (
      <div onClick={() => this.context.dialogPush('work', { id: work.id })}>
        <div>
          <Title style={{ whiteSpace: 'nowrap' }}>Work #{work.sku} - {action.name}</Title>
          <div>User: <Tag type="user" id={work.userId} /></div>
          <div>Status: {work.finish ? 'Finished' : (work.paused && 'Paused') || 'In progress'}</div>
        </div>
        {work.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    const { id, item, className, dispatch, ...props } = this.props;
    return (
      <div className={[style.container, className].join(' ')} {...props}>
        <div className={style.content}>
          {this.state.loading && 'Loading'}
          {!this.state.loading && !item && '404'}
          {!this.state.loading && item && this.renderItem()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const item = state.getIn(['work', 'items', props.id]);
  const action = state.getIn(['actions', 'items', item.get('actionId')]);
  return { item, action };
};

export default connect(mapStateToProps)(Work);



// WEBPACK FOOTER //
// ./app/components/Work/index.js